// extracted by mini-css-extract-plugin
export default {"ActionList_Heading":"CopilotSuggestions-module__ActionList_Heading--ArthG"};